<template>
  <div class="questionnaire-management">
    <el-menu
      router
      class="menu-list"
      mode="horizontal"
      :default-active="activeIndex"
    >
      <el-menu-item
        v-for="item in tabList"
        class="menu-item"
        :key="item.path"
        :index="item.path"
      >
        {{ $t(item.i18nTitle) }}
      </el-menu-item>
    </el-menu>
    <router-view class="content"/>
  </div>
</template>

<script>
import _ from 'lodash'
import { tabMenuRoute } from './route'

export default {
  data () {
    return {
      activeIndex: null
    }
  },
  computed: {
    tabList () {
      return _.map(tabMenuRoute.children, item => ({
        path: item.path,
        i18nTitle: item.meta.tabMenuLabelI18nKey
      }))
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler () {
        this.activeIndex = this.$route.path
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.questionnaire-management {
  .menu-list {
    .menu-item {
      height: 32px;
      padding: 0;
      margin: 0 20px;
      font-size: 14px;
      line-height: 30px;
      white-space: normal;

      &:first-child {
        margin-left: 0;
      }

      &.is-active {
        color: #0096cc;
        border-bottom: 1px solid #0096cc;
      }
    }
  }

  .content {
    padding-top: 20px;
  }
}
</style>
